import { useState, useEffect } from 'react'

/**
 * BEWARE - Does not work if the user holds shift AFTER focusing a select-box
 */
export function useShiftKey() {
    const [keyPressed, setKeyPressed] = useState(false)

    useEffect(() => {
        const handleKeyEvent = (e: KeyboardEvent) => {
            setKeyPressed(e.shiftKey)
        }

        window.addEventListener('keydown', handleKeyEvent)
        window.addEventListener('keyup', handleKeyEvent)

        return () => {
            window.removeEventListener('keydown', handleKeyEvent)
            window.removeEventListener('keyup', handleKeyEvent)
        }
    }, [])

    return keyPressed
}
